export default __webpack_public_path__ + "static/article-the-ins-and-outs-of-managing-your-household-budget-df501ac15081a7c0347d2b527d8ded35.webp";